import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database connection verification
export const verifyDatabaseConnection = async () => {
  try {
    // Try to access a table that should exist (users table)
    const { error } = await supabase
      .from('users')
      .select('count')
      .limit(1);
    
    if (error) {
      console.error('❌ Web App: Database connection failed:', error);
      return false;
    }
    
    console.log('✅ Web App: Successfully connected to database');
    return true;
  } catch (error) {
    console.error('❌ Web App: Database connection error:', error);
    return false;
  }
};

// Verify connection on import
verifyDatabaseConnection(); 